import { QueryKeys } from "@/constants/Query";
import { useApiMutation } from "@/hooks/useApiMutation";
import axiosInstance from "@/lib/axios";
import { useQueryClient } from "@tanstack/react-query";

interface UpdatePrescriptionParams {
  prescription: {
    pharmacy?: {
      ncpdpId?: string;
      vendorId?: string;
      vendorSystem?: string;
    };
    dispense?: {
      daysSupply?: number;
      quantity?: number;
      unit?: {
        coding?: {
          system?: string;
          code?: string;
          display?: string;
        }[];
        text?: string;
      };
      refills?: number;
      effectiveDate?: string;
    };
    sig?: string;
    noteToPharmacy?: string;
    overrideReason?: string;
    substitutionAllowed?: boolean;
    supervisingPhysicianId?: string;
    previousMedicationRequestId?: string;
    staleHeightWeightOverridden?: boolean;
  };
}

interface UpdatePrescriptionResponse {
  bundle: object;
}

export const useUpdatePrescription = ({
  patientId,
  encounterId,
  medicationRequestId,
}: {
  patientId: string;
  encounterId: string;
  medicationRequestId: string;
}) => {
  const queryClient = useQueryClient();

  return useApiMutation<UpdatePrescriptionResponse, UpdatePrescriptionParams>({
    mutationOptions: {
      mutationKey: QueryKeys.Patient.Chart.Prescriptions.UPDATE(
        patientId,
        encounterId,
        medicationRequestId,
      ),
      mutationFn: (params) => {
        return axiosInstance.patch(
          `/rx/prescriptions/${medicationRequestId}`,
          params,
        );
      },
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: QueryKeys.Patient.Chart.Prescriptions.DEFAULT(
            patientId,
            encounterId,
          ),
        });
      },
    },
  });
};
